import { Cookie } from '../utils/Cookie';

export const ReferrerCookie = {
  onLoad: function() {
    if (document.referrer !== '') {
      if ( Cookie.read('Tubular_Referrer_Tracking') ) {
        Cookie.erase('Tubular_Referrer_Tracking')
      }
      Cookie.create('Tubular_Referrer_Tracking', document.referrer, 3); // 3 days
      console.log('Tubular_Referrer_Tracking');
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/misc/ReferrerCookie.js